import { FormGroup, ValidationErrors } from '@angular/forms';

export const matchFields = (firstField: string, secondField: string, form: FormGroup): ValidationErrors | null  => {
  const match = form.controls[firstField].value === form.controls[secondField].value;
  return match ? null : { match: { firstField, secondField } };
};
